<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    src="/img/background.jpg"
    dark
    absolute
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.2)`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line v-if="this.$store.state.modules.options.app_logo">
      <v-list-item-content>
        <v-img
          class="mt-2 mb-2"
          width="70%"
          :src="this.$store.state.modules.options.app_logo"
        />
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list dense nav>
      <template v-for="(item, i) in profile">
        <base-item :key="`item-${i}`" :item="item" />
      </template>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children && $auth.check(item.permission)"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else-if="$auth.check(item.permission)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({}),

  computed: {
    items() {
      return [
        {
          icon: "mdi-view-dashboard",
          title: "dashboard",
          to: "/be"
        },
        {
          icon: "mdi-calendar",
          title: "Peoplecourseweekregistrations",
          to: "/be/peopleCourseWeekRegistration",
          permission: "peopleCourseWeekRegistration.index"
        },
        {
          icon: "mdi-account-multiple",
          title: "People",
          to: "/be/person",
          permission: "person.index"
        },
        {
          icon: "mdi-account-child",
          title: "Children",
          to: "/be/child",
          permission: "child.index"
        },
        {
          group: "",
          icon: "mdi-settings",
          title: "settings",
          permission: "course.create",
          children: [
            {
              title: "Courses",
              to: "be/course",
              permission: "course.index"
            },
            {
              title: "Locations",
              to: "be/locations",
              permission: "location.index"
            },
            {
              title: "Coursetypes",
              to: "be/courseType",
              permission: "courseType.index"
            },
            {
              title: "Options",
              to: "be/option",
              permission: "option.index"
            }
          ]
        },
        {
          icon: "mdi-account-group-outline",
          title: "usersmanagement",
          group: "",
          permission: "user.create",
          children: [
            {
              title: "users",
              to: "be/users",
              icon: "mdi-account",
              permission: "user.create"
            },
            {
              title: "roles",
              to: "be/roles",
              icon: "mdi-account",
              permission: "role.create"
            }
          ]
        },
        {
          icon: "mdi-mail",
          title: "Email Logs",
          to: "/be/emailLogs",
          permission: "emailLogs.index"
        },
      ];
    },
    drawer: {
      get() {
        return this.$store.state.modules.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return [
        {
          icon: "mdi-monitor",
          title: "Webseite",
          to: "/"
        },
        {
          icon: "mdi-account-circle",
          title: this.$auth.user().name,
          to: "/be/users/" + this.$auth.user().id
        }
      ];
    }
  },

  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    }
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title)
      };
    }
  }
};
</script>

<style lang="sass">
@import '../../../../../../../node_modules/vuetify/src/styles/tools/rtl'

#core-navigation-drawer
  z-index: 10
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important
    .v-list--nav
      padding-left: 0
      padding-right: 0

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
